import { Identifier } from "../../id";
export class ProductTypeGroupId extends Identifier {
    constructor(id) {
        super("ProductTypeGroupId", id);
    }
}
